import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ScrollbarModule } from '../../../@fury/shared/scrollbar/scrollbar.module';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';

import { ChatModule } from 'src/app/modules/chat/chat.module';

import { QuickpanelComponent } from './quickpanel.component';

@NgModule({
  imports: [CommonModule, ScrollbarModule, ChatModule, MatToolbarModule, MatIconModule, MatButtonModule],
  declarations: [QuickpanelComponent],
  exports: [CommonModule, ScrollbarModule, ChatModule, MatToolbarModule, MatIconModule, MatButtonModule, QuickpanelComponent]
})
export class QuickpanelModule {}
